/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateUserNotificationRequestDto,
    CreateUserNotificationRequestDtoFromJSON,
    CreateUserNotificationRequestDtoToJSON,
    FlaggedItemObjectType,
    FlaggedItemObjectTypeFromJSON,
    FlaggedItemObjectTypeToJSON,
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UpdateUserNotificationDto,
    UpdateUserNotificationDtoFromJSON,
    UpdateUserNotificationDtoToJSON,
    UserNotificationResponseDto,
    UserNotificationResponseDtoFromJSON,
    UserNotificationResponseDtoToJSON,
} from '../models';

export interface UserNotificationCreateUserNotificationRequest {
    createUserNotificationRequestDto?: CreateUserNotificationRequestDto;
}

export interface UserNotificationDeleteUserNotificationRequest {
    userNotificationId: string;
}

export interface UserNotificationGetUserNotificationByIdRequest {
    userNotificationId: string;
}

export interface UserNotificationGetUserNotificationsByFirmIdRequest {
    flaggedItemType?: FlaggedItemObjectType;
}

export interface UserNotificationGetUserNotificationsDetailByFlaggedItemRequest {
    flaggedItemId: string;
}

export interface UserNotificationResolveUserNotificationRequest {
    userNotificationId: string;
}

export interface UserNotificationUpdateUserNotificationRequest {
    userNotificationId: string;
    updateUserNotificationDto: UpdateUserNotificationDto;
}

/**
 * 
 */
export class UserNotificationApi extends runtime.BaseAPI {

    /**
     */
    async userNotificationCreateUserNotificationRaw(requestParameters: UserNotificationCreateUserNotificationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/UserNotification`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserNotificationRequestDtoToJSON(requestParameters.createUserNotificationRequestDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userNotificationCreateUserNotification(requestParameters: UserNotificationCreateUserNotificationRequest, initOverrides?: RequestInit): Promise<void> {
        await this.userNotificationCreateUserNotificationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userNotificationDeleteUserNotificationRaw(requestParameters: UserNotificationDeleteUserNotificationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userNotificationId === null || requestParameters.userNotificationId === undefined) {
            throw new runtime.RequiredError('userNotificationId','Required parameter requestParameters.userNotificationId was null or undefined when calling userNotificationDeleteUserNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/UserNotification/{userNotificationId}`.replace(`{${"userNotificationId"}}`, encodeURIComponent(String(requestParameters.userNotificationId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userNotificationDeleteUserNotification(requestParameters: UserNotificationDeleteUserNotificationRequest, initOverrides?: RequestInit): Promise<void> {
        await this.userNotificationDeleteUserNotificationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userNotificationGetUserNotificationByIdRaw(requestParameters: UserNotificationGetUserNotificationByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UserNotificationResponseDto>> {
        if (requestParameters.userNotificationId === null || requestParameters.userNotificationId === undefined) {
            throw new runtime.RequiredError('userNotificationId','Required parameter requestParameters.userNotificationId was null or undefined when calling userNotificationGetUserNotificationById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/UserNotification/{userNotificationId}`.replace(`{${"userNotificationId"}}`, encodeURIComponent(String(requestParameters.userNotificationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserNotificationResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async userNotificationGetUserNotificationById(requestParameters: UserNotificationGetUserNotificationByIdRequest, initOverrides?: RequestInit): Promise<UserNotificationResponseDto> {
        const response = await this.userNotificationGetUserNotificationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userNotificationGetUserNotificationsByFirmIdRaw(requestParameters: UserNotificationGetUserNotificationsByFirmIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<UserNotificationResponseDto>>> {
        const queryParameters: any = {};

        if (requestParameters.flaggedItemType !== undefined) {
            queryParameters['flaggedItemType'] = requestParameters.flaggedItemType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/UserNotification/firm`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserNotificationResponseDtoFromJSON));
    }

    /**
     */
    async userNotificationGetUserNotificationsByFirmId(requestParameters: UserNotificationGetUserNotificationsByFirmIdRequest, initOverrides?: RequestInit): Promise<Array<UserNotificationResponseDto>> {
        const response = await this.userNotificationGetUserNotificationsByFirmIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userNotificationGetUserNotificationsDetailByFlaggedItemRaw(requestParameters: UserNotificationGetUserNotificationsDetailByFlaggedItemRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<UserNotificationResponseDto>>> {
        if (requestParameters.flaggedItemId === null || requestParameters.flaggedItemId === undefined) {
            throw new runtime.RequiredError('flaggedItemId','Required parameter requestParameters.flaggedItemId was null or undefined when calling userNotificationGetUserNotificationsDetailByFlaggedItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/UserNotification/detail/{flaggedItemId}`.replace(`{${"flaggedItemId"}}`, encodeURIComponent(String(requestParameters.flaggedItemId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserNotificationResponseDtoFromJSON));
    }

    /**
     */
    async userNotificationGetUserNotificationsDetailByFlaggedItem(requestParameters: UserNotificationGetUserNotificationsDetailByFlaggedItemRequest, initOverrides?: RequestInit): Promise<Array<UserNotificationResponseDto>> {
        const response = await this.userNotificationGetUserNotificationsDetailByFlaggedItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userNotificationResolveUserNotificationRaw(requestParameters: UserNotificationResolveUserNotificationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userNotificationId === null || requestParameters.userNotificationId === undefined) {
            throw new runtime.RequiredError('userNotificationId','Required parameter requestParameters.userNotificationId was null or undefined when calling userNotificationResolveUserNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/UserNotification/{userNotificationId}/resolve`.replace(`{${"userNotificationId"}}`, encodeURIComponent(String(requestParameters.userNotificationId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userNotificationResolveUserNotification(requestParameters: UserNotificationResolveUserNotificationRequest, initOverrides?: RequestInit): Promise<void> {
        await this.userNotificationResolveUserNotificationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userNotificationUpdateUserNotificationRaw(requestParameters: UserNotificationUpdateUserNotificationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userNotificationId === null || requestParameters.userNotificationId === undefined) {
            throw new runtime.RequiredError('userNotificationId','Required parameter requestParameters.userNotificationId was null or undefined when calling userNotificationUpdateUserNotification.');
        }

        if (requestParameters.updateUserNotificationDto === null || requestParameters.updateUserNotificationDto === undefined) {
            throw new runtime.RequiredError('updateUserNotificationDto','Required parameter requestParameters.updateUserNotificationDto was null or undefined when calling userNotificationUpdateUserNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/UserNotification/{userNotificationId}`.replace(`{${"userNotificationId"}}`, encodeURIComponent(String(requestParameters.userNotificationId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserNotificationDtoToJSON(requestParameters.updateUserNotificationDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userNotificationUpdateUserNotification(requestParameters: UserNotificationUpdateUserNotificationRequest, initOverrides?: RequestInit): Promise<void> {
        await this.userNotificationUpdateUserNotificationRaw(requestParameters, initOverrides);
    }

}
